/* LevelOut: install in the Shopify theme, before the Mindbody embed script.
 * Uses the native BW_GA_EVENT message observed on 2026-09-15.
 * Does not load GTM, GA4, or access the cross-origin iframe DOM.
 */
(function () {
  'use strict';
  // Live after storefront + GA4 session continuity verification, 2026-09-15.
  var liveEnabled = true;
  var qa = new URL(window.location.href).searchParams.get('mb_v2_preview') === '1';
  if (!liveEnabled && !qa) return;
  if (window.__leveloutPricingV2Bridge) return;
  var status = window.__leveloutPricingV2Bridge = {
    version: '1.0.0', received: 0, published: 0, dropped: 0, lastDecision: 'ready'
  };
  if (qa && window.console) window.console.info('[LevelOut MB V2] ready');
  var types = {
    Pass: {category: 'pass', widgetType: 'pricing-v2-pass'},
    Package: {category: 'package', widgetType: 'pricing-v2-package'},
    Contract: {category: 'subscription', widgetType: 'pricing-v2-contract'},
    GiftCard: {category: 'gift_card', widgetType: 'pricing-v2-gift-card'}
  };
  var pending = [];
  var timer = null;
  var sequence = 0;
  var instance = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);

  function permissions() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return {
        analytics: !!privacy && privacy.analyticsProcessingAllowed() === true,
        marketing: !!privacy && privacy.marketingAllowed() === true
      };
    } catch (_) { return {analytics: false, marketing: false}; }
  }
  function id(value) {
    if (typeof value !== 'string' && typeof value !== 'number') return '';
    var result = String(value);
    return /^\d{1,16}$/.test(result) ? result : '';
  }
  function pricingFrame(source) {
    var frames = document.querySelectorAll('iframe[src]');
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow !== source) continue;
      try {
        var url = new URL(frames[i].getAttribute('src'), window.location.href);
        var match = url.pathname.match(/^\/book\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?widgets\/pricing\/view\/([a-z0-9_-]+)\/pricing\/?$/i);
        if (url.origin === 'https://go.mindbodyonline.com' && match) return match[1];
      } catch (_) { return ''; }
    }
    return '';
  }
  function productId(value) {
    // Pricing V2 uses opaque IDs such as po_... and cntr_..., not only legacy numbers.
    if (typeof value !== 'string' && typeof value !== 'number') return '';
    var result = String(value);
    return /^[A-Za-z0-9_-]{1,64}$/.test(result) ? result : '';
  }
  function drop(reason) {
    status.dropped++; status.lastDecision = reason;
    if (qa && window.console) window.console.info('[LevelOut MB V2] dropped', reason);
  }
  function attempt(entry) {
    var allowed = permissions();
    // A later grant must not recover a click made without that permission.
    entry.data.analytics_allowed = entry.data.analytics_allowed && allowed.analytics;
    entry.data.marketing_allowed = entry.data.marketing_allowed && allowed.marketing;
    if (!entry.data.analytics_allowed && !entry.data.marketing_allowed) {
      drop('consent_denied'); return true;
    }
    if (Date.now() - entry.time > 2000) { drop('publish_timeout'); return true; }
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return false;
    try {
      if (analytics.publish('mindbody_pricing_v2_click', entry.data) === false) return false;
      status.published++; status.lastDecision = 'published';
      if (qa && window.console) window.console.info('[LevelOut MB V2] published', entry.data.item_id, entry.data.widget_type);
      return true;
    } catch (_) { return false; }
  }
  function flush() {
    timer = null;
    pending = pending.filter(function (entry) { return !attempt(entry); });
    if (pending.length) timer = window.setTimeout(flush, 100);
  }
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://go.mindbodyonline.com') return;
    var envelope = event.data;
    if (!envelope || envelope.type !== 'BW_GA_EVENT') return;
    var args = envelope.payload;
    if (!Array.isArray(args) || args[0] !== 'event' || args[1] !== 'interacted') return;
    var data = args[2];
    if (!data || data.key !== 'pricing_widget_continue_add_to_cart' ||
        data.type !== 'clicked' || data.widgetName !== 'Pricing V2 Widget' ||
        data.pageName !== 'pricing_option_details') return;
    var widgetId = pricingFrame(event.source);
    if (!widgetId) return;
    status.received++;
    var siteId = id(data.siteId);
    var itemId = productId(data.pricing_option_id);
    var kind = typeof data.pricing_option_type === 'string' &&
      Object.prototype.hasOwnProperty.call(types, data.pricing_option_type) && types[data.pricing_option_type];
    if (!siteId || !itemId || !kind) { drop('invalid_product'); return; }
    var allowed = permissions();
    if (!allowed.analytics && !allowed.marketing) { drop('consent_denied'); return; }
    // Native messages lack a logical event ID. One message = one click;
    // avoid time/product throttles that would discard legitimate repeated clicks.
    var interactionId = instance + '-' + (++sequence);
    var payload = {
      source: 'mindbody_pricing_v2', link_origin: 'widget',
      detection: 'pricing_v2_native_continue', pricing_version: 'v2',
      widget_type: kind.widgetType, product_category: kind.category,
      site_id: '', mb_site_id: siteId, item_id: itemId, widget_id: widgetId,
      link_text: '', interaction_id: interactionId,
      analytics_allowed: allowed.analytics, marketing_allowed: allowed.marketing
    };
    var entry = {data: payload, time: Date.now()};
    if (!attempt(entry)) {
      if (pending.length >= 20) { drop('queue_full'); return; }
      pending.push(entry);
      if (timer === null) timer = window.setTimeout(flush, 100);
    }
  }, false);

  var shopify = window.Shopify;
  if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
    shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
      if (error) status.lastDecision = 'consent_api_unavailable';
    });
  }
})();
